import { useContext, useEffect, useState } from "react";
import CookieConsent from "react-cookie-consent";
import { Route, Switch, Link, BrowserRouter as Router, Redirect } from "react-router-dom";

import Admin from "src/app/modules/admin/Admin";
import AuthModal from "src/app/modules/auth/AuthModal";
import AuthenticatedRoute from "src/app/modules/auth/AuthenticatedRoute";
import { FORM_TYPES } from "src/app/modules/auth/constants";
import TermsAndCond from "src/app/modules/gdpr/TermsAndCond";
import User from "src/app/modules/user/User";
import iconBiscuit from "src/assets/iconsGraphics/biscuit.svg";
import { ROLE, ROUTES } from "src/config/constants";
import { AuthContext } from "src/contexts/AuthContext";
import { ModalProvider } from "src/contexts/ModalContext";
import { OpenAPI } from "src/core/helpers/api";
import { IAuth } from "src/types/global";

import "./App.css";
import ResetPassword from "./modules/auth/components/ResetPassword";
import VerifyEmail from "./modules/auth/components/VerifyEmail";
import Gdpr from "./modules/gdpr/Gdpr";
import Home from "./modules/home/Home";
import Footer from "./modules/layout/Footer";
import Header from "./modules/layout/Header";
import "./stylesheets/base.scss";
import "./stylesheets/utils.scss";

OpenAPI.BASE = process.env.REACT_APP_API_URI;

export const App = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [formType, setFormType] = useState("");
  const authData = useContext(AuthContext);
  const [userData, setUserData] = useState<IAuth | undefined | null>();

  useEffect(() => {
    setUserData(authData?.auth);
    if (authData?.auth?.targetGroup === null || authData?.auth?.targetGroup?.length === 0) {
      showAuthModal(FORM_TYPES.CONFIRM_TARGET_GROUP);
    }
  }, [authData]);

  const showPartnerModal = (isOpen: boolean) => {
    setModalOpen(isOpen);
  };

  const showAuthModal = (openedFormType: string) => {
    setModalOpen(true);
    if (openedFormType) {
      setFormType(openedFormType);
    }
  };
  const hideAuthModal = () => {
    setModalOpen(false);
    setFormType("");
  };

  const onRegistration = (success: boolean) => {
    if (success) {
      hideAuthModal();
    }
  };

  const onConfirmTargetGroup = (success: boolean) => {
    if (success) {
      hideAuthModal();
    }
  };

  const onAuthorization = (success: boolean) => {
    if (success) {
      hideAuthModal();
    }
  };

  const onResetPassword = (success: boolean) => {
    if (success) {
      hideAuthModal();
    }
  };

  const logout = () => {
    if (userData?.jwtToken) {
      authData?.clearAuthData();
    }
  };

  return (
    <div className={modalOpen ? "modalOpen" : ""}>
      <Router>
        <ModalProvider>
          <AuthModal
            isModalOpen={modalOpen}
            formType={formType}
            hideAuthModal={() => hideAuthModal()}
            onRegistration={(success: boolean) => onRegistration(success)}
            onAuthorization={(success: boolean) => onAuthorization(success)}
            onResetPassword={(success: boolean) => onResetPassword(success)}
            onConfirmTargetGroup={(success: boolean) => onConfirmTargetGroup(success)}
            userData={userData}
          />
          <Header userData={userData} showAuthModal={(formType: string) => showAuthModal(formType)} handleLogout={() => logout()} />
          <Switch>
            <Route
              exact
              path={ROUTES.home}
              render={() => (
                <Home showAuthModal={(formType: string) => showAuthModal(formType)} showPartnerModal={(isOpen: boolean) => showPartnerModal(isOpen)} />
              )}
            />
            <Route exact path={ROUTES.resetPassword} component={ResetPassword} />
            <Route exact path={ROUTES.verifyEmail} component={VerifyEmail} />
            <Route exact path={ROUTES.privacyPolicy} component={Gdpr} />
            <Route exact path={ROUTES.termsAndCond} component={TermsAndCond} />
            <AuthenticatedRoute path={ROUTES.admin} roles={[ROLE.Admin, ROLE.RegionalAdmin]} component={Admin} />
            <AuthenticatedRoute path={ROUTES.user} roles={[ROLE.User, ROLE.Admin, ROLE.RegionalAdmin]} component={User} />
            <Redirect from="*" to={ROUTES.home} />
          </Switch>
          <Footer />
          <CookieConsent location="bottom" buttonText="SLAŽEM SE" cookieName="termsOfAgreement" expires={365}>
            <div>
              <img alt="Kolačić" src={iconBiscuit} />
            </div>
            <div>
              <span className="u-t-black">
                Ova stranica koristi kolačiće za pružanje boljeg korisničkog iskustva, funkcionalnosti i prikaza sustava oglašavanja. Cookie postavke mogu se
                kontrolirati i konfigurirati u vašem web pregledniku, a više o tome možete pročitati{" "}
                <Link to={ROUTES.privacyPolicy} className="u-t-primary u-cursor-pointer">
                  ovdje
                </Link>
                . Ako pristajete na korištenje kolačića kliknite na Slažem se.
              </span>
            </div>
          </CookieConsent>
        </ModalProvider>
      </Router>
    </div>
  );
};
